/**
 * Copyright (c) 2021-2024 Kognitos, Inc. All rights reserved.
 */
import { gql } from '@apollo/client';

export const LIST_KCHAT_MESSAGES_BY_WORKER = gql`
  query ListKChatMessagesByWorker(
    $workerId: ID!
    $limit: Int = 50
    $nextToken: String
  ) {
    listKChatMessagesByWorker(
      workerId: $workerId
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        departmentId
        workerId
        message
        timestamp
        displayName
        role
      }
      nextToken
    }
  }
`;
